import {
    EffectivePermissions,
    PermissionRole,
} from '@src/services/users/myPermissions/myPermissionsApiSliceTypes';

export const ACTION_ALLOWED_ROLES: PermissionRole[] = ['admin'];

export const MODULE_KEYS: Record<
    keyof EffectivePermissions,
    keyof EffectivePermissions
> = {
    Dashboard: 'Dashboard',
    Sims: 'Sims',
    'Plan_Management.Plans': 'Plan_Management.Plans',
    'Plan_Management.Zones': 'Plan_Management.Zones',
    SubAccounts: 'SubAccounts',
    UserManagement: 'UserManagement',
    RoleManagement: 'RoleManagement',
    ActivityLogManagement: 'ActivityLogManagement',
    Countries: 'Countries',
    Operators: 'Operators',
    'B2CManagement.Users': 'B2CManagement.Users',
    'B2CManagement.Packages': 'B2CManagement.Packages',
    'B2CManagement.Discounts': 'B2CManagement.Discounts',
    'B2CManagement.Sales': 'B2CManagement.Sales',
};
